/**
 * Client-side image resize & compression.
 * Yüklenen görseli hedef max boyuta sığdırır ve kalitesini ayarlar.
 * Hem dosya boyutunu küçültür hem de sitedeki alanlara uygun hale getirir.
 */
export function resizeImage(file, { maxWidth = 1920, maxHeight = 1920, quality = 0.85 } = {}) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(url);

      let { width, height } = img;

      // Aspect ratio koruyarak küçült
      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
      }

      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          if (!blob) { reject(new Error('Canvas to blob failed')); return; }
          // Orijinal dosya adını koru ama uzantıyı .webp yap
          const name = file.name.replace(/\.[^.]+$/, '.webp');
          const resized = new File([blob], name, { type: 'image/webp' });
          resolve(resized);
        },
        'image/webp',
        quality
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Image load failed'));
    };

    img.src = url;
  });
}

/**
 * Thumbnail boyutunda küçük önizleme oluştur (admin panel için)
 */
export function createThumbnail(file, size = 300) {
  return resizeImage(file, { maxWidth: size, maxHeight: size, quality: 0.7 });
}
